<template>
    <row class="relative overflow-x-hidden h-screen" justify="center">
        <div class="rotated-background-section-light bg-block-three"></div>
        <div class="bg-circle"></div>
        <div class="bg-dot"></div>
        <overlay :close-button-offset-y="innerWidth <= 599 ? '45' : '55'" close-button-offset-x="30"
                 v-model="showMobileMenuOverlay"
        >
            <mobile-menu @hide="showMobileMenuOverlay = $event"></mobile-menu>
        </overlay>
        <column cols="full">
            <row class="relative">
                <div class="rotated-background-section bg-block-one"></div>
                <div class="rotated-background-section bg-block-two"></div>
                <row justify="center">
                    <div style="max-width: 1920px; width: 100%;" class="relative home-page-padding">
                        <div class="relative">
                            <btn @click="showMobileMenuOverlay = true"
                                 class="absolute"
                                 icon
                                 id="nav-button"
                                 style="top: 43px; left: 0; z-index: 11;"
                                 v-if="innerWidth < 1024"
                                 v-show="!showMobileMenuOverlay"
                            >
                                <icon color="white" icon="menu"></icon>
                            </btn>
                            <nav-bar class="absolute nav-bar" id="nav-bar"
                                     style="z-index: 2; top: 43px; left: 0;"
                            ></nav-bar>
                           <div style="padding-top: 208px;">
<!--                               <tw-divider class="title-position" color="white"-->
<!--                                           width="56"-->
<!--                               ></tw-divider>-->
                               <div class=" xs:text-3xl sm:text-5xl poppins-bold title-position text-white xs:w-8/12" id="title">
                                   <slot name="title"></slot>
                               </div>
                               <div class="text-3xl poppins-bold text-white title-position" id="subtitle">
                                   <slot name="subtitle"></slot>
                               </div>
                           </div>
                        </div>
                        <parallax-shapes></parallax-shapes>
                    </div>
                </row>
            </row>
            <row class="xs:mt-20 sm:mt-20 md:mt-40" justify="center">
                <column style="max-width: 1920px; width: 100%;" class="home-page-padding">
                    <slot></slot>
                </column>
            </row>
        </column>
        <website-footer style="margin-top: 130px;"></website-footer>
    </row>
</template>

<script>
    export default {
        props: {},
        components: {
            'website-footer': () => import('@/components/page/WebsiteFooter.vue'),
            // 'tw-divider': () => import('@/components/Divider.vue'),
            'nav-bar': () => import('@/components/page/NavBar.vue'),
            'mobile-menu': () => import('@/components/page/MobileMenu.vue'),
            'overlay': () => import('@/components/Overlay.vue'),
            'btn': () => import('@/components/Btn.vue'),
            'icon': () => import('@/components/display/Icon.vue'),
            'parallax-shapes': () => import('@/components/display/ParallaxShapes.vue'),
        },
        data: () => ({
            showMobileMenuOverlay: false,
            innerWidth: 0
        }),
        methods: {
            getElement(item, id) {
                return item.contentDocument.querySelector(id);
            },
            setInnerWidth() {
                this.innerWidth = window.innerWidth;
            }
        },
        mounted() {
            window.addEventListener('resize', this.setInnerWidth);
            this.setInnerWidth();
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.setInnerWidth);
        }
    };
</script>

<style scoped>
    .rotated-background-section {
        width: 2332px;
        height: 1099px;
        position: absolute;
        border-radius: 166px;
    }

    .rotated-background-section-light {
        width: 1944px;
        height: 916px;
        position: absolute;
        border-radius: 166px;
    }

    .bg-block-one {
        background: linear-gradient(to bottom left, #0174EA, #013A75);
        left: 58px;
        /*top: 138px;*/
        /*transform: translateX(-689px) rotateZ(-7deg);*/
        z-index: 0;
        bottom: -50px;
    }

    .bg-block-two {
        background-color: #082441;
        left: 58px;
        /*top: 138px;*/
        /*transform: translateX(-161px) rotateZ(-7deg);*/
        z-index: -1;
        bottom: 0px;
    }

    @media only screen and (max-width: 413px) {
        .bg-block-one {
            background: linear-gradient(to bottom left, #0174EA, #013A75);
            left: 58px;
            /*top: 138px;*/
            transform: translateX(-2057px) rotateZ(-7deg);
            z-index: 0;
        }

        .bg-block-two {
            background-color: #082441;
            left: 58px;
            /*top: 138px;*/
            transform: translateX(-161px) translateY(-120px) rotateZ(-7deg);
            z-index: -1;
        }

        .bg-block-three {
            background: linear-gradient(to bottom, rgba(1, 116, 234, 1), rgba(1, 116, 234, 0));
            opacity: 0.05;
            left: 48px;
            top: 115px;
            transform: translateX(214px) translateY(300px) rotateZ(-7deg);
            z-index: 0;
        }

        .bg-circle {
            width: 166px;
            height: 166px;
            background-color: rgba(1, 116, 234, 0.1);
            border-radius: 50%;
            left: -10px;
            top: 610px;
            position: absolute;
        }

        .bg-dot {
            width: 24px;
            height: 24px;
            box-shadow: 0 0 0 1px rgba(1, 116, 234, 0.2);
            border-radius: 50%;
            left: 15px;
            top: 790px;
            position: absolute;
        }

        .title-position {
            /*top: 170px;*/
            max-width: 300px;
            transform: translateY(-120px);
        }

        .content-position {
            margin-top: 140px;
        }

        .nav-bar {
            left: 23px;
            display: initial;
        }
    }

    @media only screen and (min-width: 414px) and (max-width: 639px) {
        .bg-block-one {
            background: linear-gradient(to bottom left, #0174EA, #013A75);
            left: 58px;
            /*top: 138px;*/
            transform: translateX(-1850px) rotateZ(-7deg);
            z-index: 0;
        }

        .bg-block-two {
            background-color: #082441;
            left: 58px;
            /*top: 138px;*/
            transform: translateX(-84px) translateY(-120px) rotateZ(-7deg);
            z-index: -1;
        }

        .bg-block-three {
            background: linear-gradient(to bottom, rgba(1, 116, 234, 1), rgba(1, 116, 234, 0));
            /*background-color: red;*/
            opacity: 0.05;
            left: 48px;
            top: 115px;
            transform: translateX(214px) translateY(300px) rotateZ(-7deg);
            z-index: 0;
        }

        .bg-circle {
            width: 166px;
            height: 166px;
            background-color: rgba(1, 116, 234, 0.1);
            border-radius: 50%;
            left: -10px;
            top: 610px;
            position: absolute;
        }

        .bg-dot {
            width: 24px;
            height: 24px;
            box-shadow: 0 0 0 1px rgba(1, 116, 234, 0.2);
            border-radius: 50%;
            left: 15px;
            top: 790px;
            position: absolute;
        }

        .title-position {
            /*top: 170px;*/
            max-width: 480px;
            transform: translateY(-100px);
        }

        .content-position {
            margin-top: 530px;
        }

        .nav-bar {
            left: 23px;
            display: initial;
        }
    }

    @media only screen and (min-width: 640px) and (max-width: 800px) {
        .bg-block-one {
            background: linear-gradient(to bottom left, #0174EA, #013A75);
            left: 58px;
            /*top: 138px;*/
            transform: translateX(-1700px) rotateZ(-7deg);
            z-index: 0;
        }

        .bg-block-two {
            background-color: #082441;
            left: 58px;
            /*top: 138px;*/
            transform: translateX(0px) translateY(-90px) rotateZ(-7deg);
            z-index: -1;
        }

        .title-position {
            /*top: 170px;*/
            transform: translateY(-100px);
            max-width: 670px;
        }

        .content-position {
            margin-top: 510px;
        }

        .nav-bar {
            left: 23px;
            display: initial;
        }
    }

    @media only screen and (min-width: 801px) and (max-width: 1024px) {
        .bg-block-one {
            background: linear-gradient(to bottom left, #0174EA, #013A75);
            left: 58px;
            /*top: 138px;*/
            transform: translateX(-1480px) rotateZ(-7deg);
            z-index: 0;
        }

        .bg-block-two {
            background-color: #082441;
            left: 58px;
            /*top: 138px;*/
            transform: translateX(0px) translateY(-70px) rotateZ(-7deg);
            z-index: -1;
        }

        .title-position {
            /*top: 190px;*/
            transform: translateY(-40px);
            max-width: 650px;
        }

        .content-position {
            margin-top: 530px;
        }

        .nav-bar {
            left: 23px;
            display: initial;
        }
    }

    @media only screen and (min-width: 1025px) and (max-width: 1152px) {
        .bg-block-one {
            background: linear-gradient(to bottom left, #0174EA, #013A75);
            left: 58px;
            /*top: 138px;*/
            transform: translateX(-1370px) rotateZ(-7deg);
            z-index: 0;
        }

        .bg-block-two {
            background-color: #082441;
            left: 58px;
            /*top: 138px;*/
            transform: translateX(0px) translateY(-70px) rotateZ(-7deg);
            z-index: -1;
        }

        .title-position {
            /*top: 190px;*/
            transform: translateY(-40px);
            max-width: 600px;
        }

        .content-position {
            margin-top: 650px;
        }

        .nav-bar {
            left: 23px;
            display: initial;
        }
    }

    @media only screen and (min-width: 1153px) and (max-width: 1366px) {
        .bg-block-one {
            background: linear-gradient(to bottom left, #0174EA, #013A75);
            left: 58px;
            /*top: 138px;*/
            transform: translateX(-1130px) rotateZ(-7deg);
            z-index: 0;
        }

        .bg-block-two {
            background-color: #082441;
            left: 58px;
            /*top: 138px;*/
            transform: translateX(0px) translateY(-30px) rotateZ(-7deg);
            z-index: -1;
        }

        .title-position {
            /*top: 250px;*/
            transform: translateY(-30px);
            max-width: 700px;
        }

        .content-position {
            margin-top: 610px;
        }

        .nav-bar {
            left: 23px;
            display: initial;
        }
    }

    @media only screen and (min-width: 1367px) and (max-width: 1500px) {
        .bg-block-one {
            background: linear-gradient(to bottom left, #0174EA, #013A75);
            left: 58px;
            /*top: 138px;*/
            transform: translateX(-1030px) rotateZ(-7deg);
            z-index: 0;
        }

        .bg-block-two {
            background-color: #082441;
            left: 58px;
            /*top: 138px;*/
            transform: translateX(0px) translateY(-30px) rotateZ(-7deg);
            z-index: -1;
        }

        .title-position {
            /*top: 250px;*/
            transform: translateY(-30px);
            max-width: 750px;
        }

        .content-position {
            margin-top: 650px;
        }

        .nav-bar {
            left: 23px;
        }
    }

    @media only screen and (min-width: 1501px) and (max-width: 1919px) {
        .bg-block-one {
            background: linear-gradient(to bottom left, #0174EA, #013A75);
            left: 58px;
            /*top: 138px;*/
            transform: translateX(-650px) rotateZ(-7deg);
            z-index: 0;
        }

        .bg-block-two {
            background-color: #082441;
            left: 58px;
            /*top: 138px;*/
            transform: translateX(84px) rotateZ(-7deg);
            z-index: -1;
        }

        .title-position {
            /*top: 250px;*/
            transform: translateY(-30px);
            max-width: 950px;
        }

        .content-position {
            margin-top: 630px;
        }
    }

    /*and (max-width: 2559px)*/
    @media only screen and (min-width: 1920px) {
        .bg-block-one {
            background: linear-gradient(to bottom left, #0174EA, #013A75);
            left: 58px;
            /*top: 138px;*/
            transform: translateX(-600px) rotateZ(-7deg);
            z-index: 0;
        }

        .bg-block-two {
            background-color: #082441;
            left: 58px;
            /*top: 138px;*/
            transform: translateX(84px) rotateZ(-7deg);
            z-index: -1;
        }

        .title-position {
            /*top: 100px;*/
            transform: translateY(-30px);
            max-width: 1000px;
        }

        .content-position {
            margin-top: 680px;
        }
    }

    @media only screen and (min-width: 2560px) {
    /*    .bg-block-one {*/
    /*        background: linear-gradient(to bottom left, #0174EA, #013A75);*/
    /*        left: 58px;*/
    /*        !*top: 138px;*!*/
    /*        transform: translateX(170px) rotateZ(-7deg);*/
    /*        z-index: 0;*/
    /*    }*/

    /*    .bg-block-two {*/
    /*        background-color: #082441;*/
    /*        left: 58px;*/
    /*        !*top: 138px;*!*/
    /*        transform: translateX(1200px) rotateZ(-7deg);*/
    /*        z-index: -1;*/
    /*    }*/

        .title-position {
            /*top: 250px;*/
            transform: translateY(-30px);
            max-width: 650px;
        }

    /*    .content-position {*/
    /*        margin-top: 650px;*/
    /*    }*/
    }

    @media only screen and (min-width: 640px) and (max-width: 1919px) {
        .bg-block-three {
            background: linear-gradient(to bottom, rgba(1, 116, 234, 1), rgba(1, 116, 234, 0));
            opacity: 0.05;
            left: 48px;
            top: 115px;
            transform: translateX(314px) translateY(542px) rotateZ(-7deg);
            z-index: 0;
        }

        .bg-circle {
            width: 166px;
            height: 166px;
            background-color: rgba(1, 116, 234, 0.1);
            border-radius: 50%;
            left: 60px;
            top: 770px;
            position: absolute;
        }

        .bg-dot {
            width: 24px;
            height: 24px;
            box-shadow: 0 0 0 1px rgba(1, 116, 234, 0.2);
            border-radius: 50%;
            left: 40px;
            top: 950px;
            position: absolute;
        }
    }

    @media only screen and (min-width: 1920px) {
        .bg-block-three {
            background: linear-gradient(to bottom, rgba(1, 116, 234, 1), rgba(1, 116, 234, 0));
            opacity: 0.05;
            left: 48px;
            top: 115px;
            transform: translateX(914px) translateY(842px) rotateZ(-7deg);
            z-index: 0;
        }

        .bg-circle {
            width: 166px;
            height: 166px;
            background-color: rgba(1, 116, 234, 0.1);
            border-radius: 50%;
            /*left: 60px;*/
            /*top: 920px;*/
            transform: translateX(-800px) translateY(800px);
            position: absolute;
        }

        .bg-dot {
            width: 24px;
            height: 24px;
            box-shadow: 0 0 0 1px rgba(1, 116, 234, 0.2);
            border-radius: 50%;
            /*left: 40px;*/
            /*top: 1100px;*/
            transform: translateX(-880px) translateY(1000px);
            position: absolute;
        }
    }

    @media only screen and (max-width: 1639px) {
        .home-page-padding {
            padding: 0 23px;
        }

        .nav-bar {
            left: 23px;
            display: initial;
        }
    }

    @media only screen and (min-width: 1640px) {
        .home-page-padding {
            padding: 0 139px;
        }
    }
</style>